// Styles standard des sous-pages (listes, formulaires, fenêtres).
// Chaque page fait `header: S.header` ou `{ ...S.x, ajustement }` dans son objet `styles`.
// `var(--accent)` prend la couleur du profil connecté (définie par AppLayout).

const border = '1px solid #E2E8F0';
const shadow = '0 1px 2px rgba(15,23,42,0.04)';
const champ = {
  minHeight: 44, padding: '10px 14px', borderRadius: 10, border: '1px solid #CBD5E1',
  fontSize: 14, color: '#0F172A', background: 'white', width: '100%', boxSizing: 'border-box',
};
const btnBase = {
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
  minHeight: 42, padding: '0 18px', borderRadius: 10, fontSize: 14, fontWeight: 600,
};
const btnIcone = (bg, fg) => ({
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6,
  minWidth: 36, minHeight: 36, padding: '0 10px', borderRadius: 8, border: 'none',
  background: bg, color: fg, fontSize: 14, fontWeight: 600,
});

export const S = {
  contenu: { flex: 1, padding: 'clamp(16px, 3vw, 28px)', paddingBottom: 48 },

  // En-tête de page : titre à gauche, actions à droite, sans boîte
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', gap: 16, flexWrap: 'wrap', marginBottom: 24 },
  headerTitre: { fontSize: 24, fontWeight: 800, color: '#0F172A', margin: 0, letterSpacing: '-0.02em' },
  headerSousTitre: { color: '#64748B', fontSize: 14, margin: '4px 0 0' },

  // Boutons
  boutonAjouter: { ...btnBase, background: 'var(--accent)', color: 'white', border: 'none' },
  boutonSecondaire: { ...btnBase, background: 'white', color: '#0F172A', border: '1px solid #CBD5E1' },
  boutonRetour: { ...btnBase, background: 'white', color: '#334155', border: '1px solid #CBD5E1' },
  btnSauvegarder: { ...btnBase, minHeight: 44, padding: '0 24px', background: 'var(--accent)', color: 'white', border: 'none' },
  btnAnnuler: { ...btnBase, minHeight: 44, background: 'white', color: '#334155', border: '1px solid #CBD5E1' },
  btnDanger: { ...btnBase, minHeight: 44, background: '#DC2626', color: 'white', border: 'none' },

  // Boutons d'action dans les lignes / cartes
  btnModifier: btnIcone('#EFF6FF', '#1D4ED8'),
  btnVoir: btnIcone('#F1F5F9', '#334155'),
  btnAppro: btnIcone('#ECFDF5', '#047857'),
  btnPerte: btnIcone('#FFF7ED', '#C2410C'),
  btnActiver: btnIcone('#ECFDF5', '#047857'),
  btnDesactiver: btnIcone('#FEF2F2', '#B91C1C'),

  // Conteneurs
  section: { background: 'white', borderRadius: 14, padding: '18px 20px', border, boxShadow: shadow, overflowX: 'auto' },
  sectionTitre: { fontSize: 15, fontWeight: 700, color: '#0F172A', margin: '0 0 14px' },
  filtres: { background: 'white', borderRadius: 14, padding: '12px 14px', marginBottom: 16, border, display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' },
  etabSelector: { background: 'white', borderRadius: 14, padding: '14px 16px', marginBottom: 20, border },
  etabSelectorTitre: { fontSize: 12, fontWeight: 600, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 10 },
  vide: { textAlign: 'center', padding: '48px 16px', color: '#64748B' },

  // Statistiques
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(180px, 100%), 1fr))', gap: 12, marginBottom: 20 },
  statCard: { padding: '16px 18px', borderRadius: 14, border, boxShadow: shadow, textAlign: 'center', background: 'white' },
  resumeGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(200px, 100%), 1fr))', gap: 12, marginBottom: 24 },
  resumeCard: { padding: '16px 18px', borderRadius: 14, border, boxShadow: shadow, textAlign: 'center', background: 'white' },

  // Tableaux
  table: { width: '100%', borderCollapse: 'collapse', fontVariantNumeric: 'tabular-nums' },
  tableHeader: { background: '#F8FAFC' },
  th: { padding: '10px 14px', color: '#64748B', fontSize: 12, textAlign: 'left', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em', borderBottom: border, whiteSpace: 'nowrap' },
  td: { padding: '12px 14px', fontSize: 14, color: '#0F172A', borderBottom: '1px solid #F1F5F9', verticalAlign: 'middle' },

  // Pagination
  pagination: { display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 6, marginTop: 16, flexWrap: 'wrap' },
  pagBtn: { minWidth: 36, height: 36, padding: '0 12px', background: 'white', color: '#334155', border: '1px solid #CBD5E1', borderRadius: 8, fontSize: 14, fontWeight: 600 },
  pagNum: { minWidth: 36, height: 36, borderRadius: 8, border: 'none', fontWeight: 600, fontSize: 14 },

  // Formulaires
  formCard: { background: 'white', borderRadius: 16, padding: 'clamp(18px, 3vw, 28px)', border, boxShadow: shadow },
  formTitre: { fontSize: 20, fontWeight: 800, color: '#0F172A', margin: '0 0 20px', letterSpacing: '-0.01em' },
  sectionForm: { marginBottom: 20, padding: 18, background: '#F8FAFC', borderRadius: 12, border },
  sectionFormTitre: { fontSize: 14, fontWeight: 700, color: '#0F172A', margin: '0 0 14px', display: 'flex', alignItems: 'center', gap: 8 },
  formGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(240px, 100%), 1fr))', gap: 16 },
  champGroupe: { display: 'flex', flexDirection: 'column', gap: 6 },
  label: { fontSize: 13, fontWeight: 600, color: '#334155' },
  input: champ,
  select: champ,
  rechercheInput: { ...champ, flex: '1 1 220px', width: 'auto', minWidth: 0 },
  filtreSelect: { ...champ, width: 'auto', minWidth: 160 },
  formActions: { display: 'flex', gap: 10, justifyContent: 'flex-end', flexWrap: 'wrap', marginTop: 16 },

  // Fenêtres
  overlay: { position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, zIndex: 1000 },
  modal: { background: 'white', borderRadius: 16, padding: 24, width: 'min(460px, 100%)', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 50px rgba(15,23,42,0.25)' },

  // Message de retour : notification en haut à droite
  messageBox: { position: 'fixed', top: 16, right: 16, zIndex: 1100, maxWidth: 'calc(100vw - 32px)', padding: '12px 18px', borderRadius: 12, fontWeight: 600, fontSize: 14, boxShadow: '0 8px 24px rgba(15,23,42,0.15)', animation: 'sp-fade-up .2s ease both' },
};
S.modalOverlay = S.overlay;
S.btnFermer = { ...S.btnAnnuler, flex: 1 };
S.btnAnnulerModal = { ...S.btnDanger, flex: 1 };
S.btnAnnulerBtn = S.btnDesactiver;
S.btnAnnulerVente = S.btnDesactiver;
S.btnConfirmerAnnulation = S.btnDanger;
S.btnValider = S.btnSauvegarder;
